import React from 'react';

const Parser = require('html-to-react').Parser;
const parser = new Parser();

const icon = require('../../assets/search-24px.svg');

export default function SearchIcon() {
    return parser.parse(icon);
}
